import React from 'react'

function OnboardingHomeBg() {
    return (
        <>
            <img src="/assets/cube-bg.svg" alt="cube background" style={{
                position: "absolute",
                width: "203px",
                height: "203px",
                left: "80px",
                bottom: "-40px",
                transform: "rotate(10deg)",
                pointerEvents: "none"
            }} />
            <img src="/assets/cube-bg.svg" alt="cube background" style={{
                position: "absolute",
                width: "226px",
                height: "226px",
                right: "-60px",
                bottom: "50%",
                transform: "rotate(16deg)",
                pointerEvents: "none"
            }} />
            <img src="/assets/process-bg.svg" alt="cube background" style={{
                position: "absolute",
                right: "86px",
                bottom: "-75px",
                transform: "rotate(16deg)",
                width: "153px",
                height: "153px",
                pointerEvents: "none"
            }} />
      </>
    );
};

export default OnboardingHomeBg;
